/*
 * slider-counter-fix.js
 * ---------------------------------------------------------------------------
 * FIX: Mobile product gallery counter showed one more slide than exists
 *      (e.g. "4 / 5" on a product with only 4 images), and the phantom final
 *      slide could not be reached.
 *
 * CAUSE: In assets/global.js, SliderComponent.initPages() computes:
 *
 *     this.slidesPerPage = Math.floor(
 *       (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
 *     );
 *     this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
 *
 *   The product gallery uses the `grid--peek` layout on mobile, where a slide
 *   is wider than the visible track. That makes the Math.floor(...) evaluate to
 *   0, so totalPages becomes (length - 0 + 1) = length + 1. update() then writes
 *   that value into .slider-counter--total, overwriting the correct Liquid value.
 *
 * FIX: Clamp slidesPerPage to a minimum of 1. Where slidesPerPage was already
 *   >= 1 (desktop, thumbnails, every other slider) Math.max(1, x) is a no-op,
 *   so this cannot regress any other slider on the site.
 *
 * NOTE FOR DEVELOPER: The canonical one-line fix is in assets/global.js:
 *   this.slidesPerPage = Math.max(1, Math.floor(...));
 * This file is a scoped, non-destructive override so the change is easy to
 * review and revert. Fold it into global.js whenever convenient.
 */
(function () {
  var PATCH_FLAG = '__counterPatched';

  function patchInstance(el) {
    if (!el || el[PATCH_FLAG] || typeof el.initPages !== 'function') return;
    el[PATCH_FLAG] = true;

    var originalInitPages = el.initPages.bind(el);

    el.initPages = function () {
      originalInitPages();

      // Only correct the broken case; leave healthy sliders untouched.
      if (typeof this.slidesPerPage === 'number' && this.slidesPerPage < 1 && this.sliderItemsToShow) {
        this.slidesPerPage = 1;
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        if (typeof this.update === 'function') this.update();
      }
    };

    el.initPages();
  }

  function patchAll() {
    document.querySelectorAll('slider-component').forEach(patchInstance);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('slider-component').then(patchAll).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAll);
  } else {
    patchAll();
  }

  // Variant changes re-render the gallery; re-patch any fresh instances.
  document.addEventListener('shopify:section:load', patchAll);
  window.addEventListener('load', patchAll);
})();
